import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { AppState, Dispatch } from 'store/types'
import {
  fecthEstimateById,
  downloadPDF,
  goToPDF,
  getPDFOnEmail
} from 'ducks/estimates/operations'
import EstimateInfo from 'components/estimates/EstimateInfo'
import { Button } from 'components/UI/Button'
import { history, routePath } from 'routes'

class EstimateView extends Component<Props> {
  componentDidMount() {
    const {
      match: {
        params: { id }
      },
      isAuthenticated
    } = this.props
    if (isAuthenticated) {
      this.props.fecthEstimateById(id)
    }
  }
  componentDidUpdate(prevProps: Readonly<Props>): void {
    const {
      match: {
        params: { id }
      },
      isAuthenticated
    } = this.props
    if (prevProps.isAuthenticated !== isAuthenticated) {
      this.props.fecthEstimateById(id)
    }
  }

  goBack = () => {
    const { isAuthenticated } = this.props
    if (isAuthenticated) {
        history.push(routePath.ESTIMATES_PAGE)
    } else {
        history.goBack();
    }
  }

  onDownloadClick = () => {
    const { id } = this.props.estimate
    const { isAuthenticated, publicEstimate } = this.props
    this.props.downloadPDF(isAuthenticated ? id : publicEstimate.id)
  }

  onPrintClick = () => {
    const { id } = this.props.estimate
    const { isAuthenticated, publicEstimate } = this.props
    this.props.goToPDF(isAuthenticated ? id : publicEstimate.id)
    // this.props.goToPDF(id)
  }

  onEmailClick = () => {
    const { id } = this.props.estimate
    this.props.getPDFOnEmail(id)
  }

  render() {
    const {
      isFetching,
      match: {
        params: { isNew }
      },
      estimate,
      isAdmin,
      isAuthenticated,
      publicEstimate
    } = this.props
    return (
      <WrapBlock>
        {console.log('this.props', this.props.publicEstimate)}
        <Fragment>
          <EstimateInfo
            isFetching={isFetching}
            isAdmin={isAdmin}
            data={isAuthenticated ? estimate : publicEstimate}
            isAuthenticated={isAuthenticated}
            onDownloadClick={this.onDownloadClick}
            onPrintClick={this.onPrintClick}
            onEmailClick={this.onEmailClick}
          />
          {/* {isAuthenticated && ( */}
            <BottomBlock>
              <Button variant={'secondary'} onClick={this.goBack}>
                {/* {isNew === 'true' ? 'Next' : 'Back'} */}
                Back
              </Button>
            </BottomBlock>
          {/* )} */}
        </Fragment>
      </WrapBlock>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  isFetching: state.estimates.isFetching,
  estimate: state.estimates.estimate,
  publicEstimate: state.estimates.publicEstimate,
  isAdmin: state.auth.isAdmin,
  isAuthenticated: state.auth.isAuthenticated
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      fecthEstimateById,
      downloadPDF,
      goToPDF,
      getPDFOnEmail
    },
    dispatch
  )

interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps & any

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimateView)

const WrapBlock = styled.div``

const BottomBlock = styled.div`
  display: flex-end;
  align-items: center;
`
